import { Card, CardBody, Col } from "reactstrap";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { ItemsSliderProp } from "../../../../../Types/Dashboard.type";
import SliderContent from "./SliderContent";

export default function ItemsSlider({ data }: ItemsSliderProp) {
  return (
    <>
      {data.map((item) => (
        <Col sm={6} key={item.id} className={`box-col-6 ${item.colClass}`}>
          <Card>
            <CardBody>
              <div className="items-slider">
                <Swiper
                  className="mySwiper1"
                  spaceBetween={50}
                  navigation
                  slidesPerView={1}
                  modules={[Navigation, Autoplay]}
                  autoplay={{ delay: 1500, disableOnInteraction: false }}
                  loop={true}
                  breakpoints={{
                    500: { slidesPerView: 1, spaceBetween: 20 },
                    769: { slidesPerView: 1, spaceBetween: 40 },
                    1530: { slidesPerView: 1, spaceBetween: 25 },
                  }}
                >
                  <div className="swiper-wrapper">
                    {item.slider.map((list) => (
                      <SwiperSlide key={list.id}>
                        <SliderContent list={list} />
                      </SwiperSlide>
                    ))}
                  </div>
                </Swiper>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </>
  );
}
